import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  top: 0;
  z-index: 110;
  margin-top: 45px;
`;

export const Iframe = styled.iframe`
  border: none;
  padding-left: 60px;
  width: 100%;
`;
